export class Transaction {
    creatorType: string;
    detailMessage: string;
    reward: string;
    transactionType: string;
    walletCode: number;
    accrued?: number;
    isQualified?: boolean;
    isOffer?: boolean;
    isRedeemed?: boolean;
    redeemed?: number;
    rewardValue?: number;
}
